import { zodResolver } from '@hookform/resolvers/zod'
import { Modal } from 'antd'
import { useForm } from 'react-hook-form'
import { toast } from 'sonner'

import AtomFormInput from '@/components/Atoms/AtomFormInput/AtomFormInput'
import { useUserInfoStore } from '@/stores/user/userInfoStore'
import {
  FormInputControlType,
  FormInputNameType,
  FormInputRegisterType,
} from '@/types'
import api from '@/utils/api/api'
import { handleApiError } from '@/utils/api/errors/handleApiError'

import {
  constructionSiteCreationSchema,
  ConstructionSiteCreationType,
  FORM_FIELDS,
} from './ConstructionSiteCreationForm.config'
import cn from './ConstructionSiteCreationForm.module.scss'

type ConstructionSiteCreationFormPropsType = {
  location: 'orderCreation' | 'constructionSites'
  setUpdateConstructionSites: (updateConstructionSites: boolean) => void
}

function ConstructionSiteCreationForm(
  props: ConstructionSiteCreationFormPropsType
) {
  const { location, setUpdateConstructionSites } = props
  const { organisation, selectedOrganisation } = useUserInfoStore(
    (state) => state
  )
  const [modal, contextHolder] = Modal.useModal()

  const {
    register,
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<ConstructionSiteCreationType>({
    shouldFocusError: false,
    resolver: zodResolver(constructionSiteCreationSchema),
  })

  const onSubmit = (data: ConstructionSiteCreationType) => {
    const orgId = selectedOrganisation?.id || organisation?.id
    const loadingToast = toast.loading('Создание объекта...')

    api
      .post(`/organisations/${orgId}/construction-sites`, {
        ...data,
        isActive: true,
        isMain: false,
        isStore: false,
      })
      .then(() => {
        toast.success('Объект успешно создан', { id: loadingToast })
        setUpdateConstructionSites(true)
        reset()
      })
      .catch((e) => {
        toast.dismiss(loadingToast)
        handleApiError(e, modal)
      })
  }

  return (
    <>
      {contextHolder}
      <form
        className={[cn.form, cn[location]].join(' ')}
        onSubmit={handleSubmit(onSubmit)}
      >
        <div className={[cn.inputs, cn[location]].join(' ')}>
          {FORM_FIELDS.map((field) => (
            <AtomFormInput
              key={field.id}
              location="constructionSiteCreation"
              name={field.name as FormInputNameType}
              placeholder={field.placeholder}
              errors={errors}
              control={control as unknown as FormInputControlType}
              register={register as FormInputRegisterType}
            />
          ))}
        </div>
        <div className={[cn.buttonBlock, cn[location]].join(' ')}>
          <button type="submit" className={[cn.button, cn[location]].join(' ')}>
            Создать объект
          </button>
        </div>
      </form>
    </>
  )
}

export default ConstructionSiteCreationForm
